import React from 'react'

import PropTypes from 'prop-types'
import { Button, Tooltip } from '@material-ui/core'

const BulkActionButton = ({
  label,
  icon,
  hint,
  disabledHint,
  disabled = false,
  className,
  onClick,
}) => {
  return (
    <Tooltip title={disabled ? disabledHint : hint || ''}>
      <span>
        <Button
          variant="outlined"
          size="small"
          startIcon={icon}
          onClick={onClick}
          disabled={disabled}
          className={className}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  )
}

BulkActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  hint: PropTypes.string,
  disabledHint: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default BulkActionButton
